module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.fails.js
 ** module id = 9
 ** module chunks = 0
 **/